export const getScores = (maxScore: number, score?: number) => {
  const scores = [];
  for (let i = 1; i <= maxScore; i++) {
    const isSelected = score === i;
    scores.push({
      value: i,
      isSelected,
      score: i,
    });
  }
  scores.push({
    value: 'N/A',
    isSelected: score === -1,
    score: -1,
  });
  return scores;
};
